import axios from 'axios'
import { calls } from '../utils/calls.js'
import {
  capitalizeWord,
  createError,
  filterFabrics,
  setURLParams,
  updateFilterResponse,
} from '../utils/utils.js'
import { convertWooCommerceRequestParametersToImprovedCustomAPI } from '../utils/format'

const CancelToken = axios.CancelToken

export const getFabrics = (params = [], setFilters = true, prefix = 'search') => {
  return (dispatch, getState) => {
    const { fabrics } = getState()
    const { frontendFilters, cancel } = fabrics

    if (setFilters) {
      dispatch({ type: 'SET_FILTERS', payload: { params } })
    }

    if (frontendFilters?.showOnlyFavourites) {
      // this to be changed when the backend decides to support sending id for favorites in query and return only favorites
      // at the moment the favorites are filtered in the frontend after the response is received from the backend
      // because of that we need to get all the fabrics and filter them in the frontend
      // this is a temporary solution until the backend is ready to support this feature and return only favorites in the response
      params = params.map((param) => {
        if (param.name === 'per_page') {
          return { name: 'per_page', value: 1000000 }
        }
        return param
      })
    }

    const filters = setURLParams(
      '',
      convertWooCommerceRequestParametersToImprovedCustomAPI(params),
      prefix,
    )

    if (cancel) {
      cancel()
    }

    dispatch({ type: 'GET_FABRICS' })

    return axios(calls.getFabrics(filters, CancelToken, dispatch))
      .then((res) => {
        const updatedFilterResponse = updateFilterResponse(res.data, fabrics)
        const filteredItems = filterFabrics(frontendFilters, updatedFilterResponse, fabrics)
        dispatch({
          type: 'GET_FABRICS_FULFILLED',
          payload: {
            items: updatedFilterResponse,
            filteredItems: filteredItems,
          },
        })
      })
      .catch((err) => {
        dispatch({
          type: 'GET_FABRICS_REJECTED',
          payload: { err: createError(err) },
        })
      })
  }
}

export const getFabricsDataByName = (fabricName, dispatch, prefix = 'search') => {
  const filters = setURLParams(
    '',
    convertWooCommerceRequestParametersToImprovedCustomAPI([{ name: 'search', value: fabricName }]),
    prefix,
  )
  return axios(calls.getFabrics(filters, CancelToken, dispatch))
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      createError(err)
    })
}

export const getCordingFabrics = (params = [], setFilters = true, prefix = 'search') => {
  return (dispatch, getState) => {
    const { fabrics } = getState()
    const { frontendFilters, cancel } = fabrics

    if (setFilters) {
      dispatch({ type: 'SET_CORDING_FILTERS', payload: { params } })
    }

    if (frontendFilters?.showOnlyFavourites) {
      params = params.map((param) => {
        if (param.name === 'per_page') {
          return { name: 'per_page', value: 1000000 }
        }
        return param
      })
    }

    const filters = setURLParams(
      '',
      convertWooCommerceRequestParametersToImprovedCustomAPI(params),
      prefix,
    )

    if (cancel) {
      cancel()
    }

    dispatch({ type: 'GET_CORDING_FABRICS' })

    return axios(calls.getMoreFabrics(filters))
      .then((res) => {
        const updatedFilterResponse = updateFilterResponse(res.data, fabrics)
        const filteredItems = filterFabrics(frontendFilters, updatedFilterResponse, fabrics)
        dispatch({
          type: 'GET_CORDING_FABRICS_FULFILLED',
          payload: {
            items: res.data,
            filteredItems: filteredItems,
          },
        })
      })
      .catch((err) => {
        dispatch({
          type: 'GET_CORDING_FABRICS_REJECTED',
          payload: { err: createError(err) },
        })
      })
  }
}

export const getFabricsForKits = () => {
  return (dispatch) => {
    return axios(calls.getAllFabricsWithAllProperties(1))
      .then((res) => {
        return axios(calls.getAllFabricsWithAllProperties(2))
          .then((res2) => {
            let allFabrics = [...res.data, ...res2.data]
            dispatch({
              type: 'SET_ALL_FABRICS_FOR_KITS',
              payload: {
                fabricsKits: allFabrics,
              },
            })
            dispatch({
              type: 'GET_COLORS_FULFILLED',
              payload: {
                items: allFabrics,
              },
            })
          })
          .catch((err) => createError(err))
      })
      .catch((err) => {
        createError(err)
      })
  }
}

export const getBrands = () => {
  return (dispatch) => {
    dispatch({ type: 'GET_BRANDS' })
    return axios(calls.getBrands())
      .then((res) => {
        const brands = Object.keys(res.data).map((key) => ({
          id: key,
          name: capitalizeWord(res.data[key].name),
          fabricsCare: res.data[key].fabrics_care,
        }))
        dispatch({
          type: 'GET_BRANDS_FULFILLED',
          payload: { items: brands },
        })
      })
      .catch((err) => {
        dispatch({
          type: 'GET_BRANDS_REJECTED',
          payload: { err: createError(err) },
        })
      })
  }
}

export const getMaterials = () => {
  return (dispatch) => {
    dispatch({ type: 'GET_MATERIALS' })
    return axios(calls.getMaterials())
      .then((res) => {
        const materials = Object.keys(res.data).map((key) => ({
          id: key,
          terms: [key, ...res.data[key].terms.map((term) => term.id)],
          vals: res.data[key].terms,
          name: capitalizeWord(res.data[key].name),
        }))
        dispatch({
          type: 'GET_MATERIALS_FULFILLED',
          payload: { items: materials },
        })
      })
      .catch((err) => {
        dispatch({
          type: 'GET_MATERIALS_REJECTED',
          payload: { err: createError(err) },
        })
      })
  }
}

export const getUses = () => {
  return (dispatch) => {
    dispatch({ type: 'GET_USES' })
    return axios(calls.getUses())
      .then((res) => {
        dispatch({
          type: 'GET_USES_FULFILLED',
          payload: { items: res.data },
        })
      })
      .catch((err) => {
        dispatch({
          type: 'GET_USES_REJECTED',
          payload: { err: createError(err) },
        })
      })
  }
}

export const getPatterns = () => {
  return (dispatch) => {
    dispatch({ type: 'GET_PATTERNS' })
    return axios(calls.getPatterns())
      .then((res) => {
        dispatch({
          type: 'GET_PATTERNS_FULFILLED',
          payload: { items: res.data },
        })
      })
      .catch((err) => {
        dispatch({
          type: 'GET_PATTERNS_REJECTED',
          payload: { err: createError(err) },
        })
      })
  }
}

export const getColorMap = () => {
  return (dispatch) => {
    dispatch({ type: 'GET_COLOR_MAP' })
    return axios(calls.getColorMap())
      .then((res) => {
        dispatch({
          type: 'GET_COLOR_MAP_FULFILLED',
          payload: { items: res.data },
        })
      })
      .catch((err) => {
        dispatch({
          type: 'GET_COLOR_MAP_REJECTED',
          payload: { err: createError(err) },
        })
      })
  }
}

export const setFilters = (params) => {
  return (dispatch) => {
    dispatch({ type: 'SET_FILTERS', payload: { params } })
  }
}

export const setCordingFilters = (params) => {
  return (dispatch) => {
    dispatch({ type: 'SET_CORDING_FILTERS', payload: { params } })
  }
}

export const setFrontendFilters = (params) => {
  return (dispatch) => {
    dispatch({ type: 'SET_FRONTEND_FILTERS', payload: { params } })
  }
}

export const setFrontendCordingFilters = (params) => {
  return (dispatch) => {
    dispatch({ type: 'SET_FRONTEND_CORDING_FILTERS', payload: { params } })
  }
}

export const setFilteredFabrics = (filteredFabrics) => {
  return (dispatch) => {
    dispatch({ type: 'SET_FILTERED_FABRICS', payload: { items: filteredFabrics } })
  }
}

export const addPreselectedFabric = (fabric) => {
  return (dispatch) => {
    dispatch({ type: 'ADD_PRESELECTED_FABRIC', payload: { fabric } })
  }
}

export const addPreselectedCordedFabric = (fabric) => {
  return (dispatch) => {
    dispatch({ type: 'ADD_PRESELECTED_CORD_FABRIC', payload: { fabric } })
  }
}

export const setFilteredCordingFabrics = (filteredCordingFabrics) => {
  return (dispatch) => {
    dispatch({ type: 'SET_FILTERED_CORDING_FABRICS', payload: { items: filteredCordingFabrics } })
  }
}

export const setIsOneCustomAttributeAPIFilterApplied = (value) => {
  return (dispatch) => {
    dispatch({ type: 'SET_IS_ONE_CUSTOM_ATTRIBUTE_API_FILTER_APPLIED', payload: { value: value } })
  }
}

export const setColorApiFilters = (colors) => {
  return (dispatch) => {
    dispatch({ type: 'SET_COLOR_API_FILTERS', payload: { colors } })
  }
}

export const getMoreFabrics = (filters) => {
  return new Promise((resolve, reject) => {
    return axios(calls.getMoreFabrics(filters))
      .then((res) => resolve(res.data))
      .catch((err) => {
        createError(err)
        reject(err)
      })
  })
}

export const getWestchaseFabrics = (filters) => {
  return new Promise((resolve, reject) => {
    return axios(calls.getWestchaseFabrics(filters))
      .then((res) => resolve(res.data))
      .catch((err) => {
        createError(err)
        reject(err)
      })
  })
}

export const getAllFabrics = () => {
  return new Promise((resolve, reject) => {
    return axios(calls.getAllFabricsWithAllProperties(1))
      .then((res) => resolve(res.data))
      .catch((err) => {
        createError(err)
        reject(err)
      })
  })
}

export const setStockApiFilters = (stock) => {
  return (dispatch) => {
    dispatch({ type: 'SET_STOCK_API_FILTERS', payload: { stock: stock } })
  }
}

export const setCordingFabrics = (cordingFabrics) => {
  return (dispatch) => {
    dispatch({ type: 'SET_CORDING_FABRICS', payload: { cordingFabrics: cordingFabrics } })
  }
}

export const setScrollPosition = (scrollTop) => {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_SCROLL_POSITION', scrollTop })
  }
}
